'use strict';

import { getVueTemplate } from '../_imports/utils/utils.common';
import { decodeHtml } from '../_imports/shared/vue-utils.common';

const cta = {
    template: getVueTemplate('call-to-action'),
    mixins: [
        decodeHtml
    ],
    props: {
        button: Object,
        label: String,
        link: String,
        target: String,
        displayStyle: String,
        tracking: String
    },
    data() {
        return {
            classes: [],
            buttonLabel: null,
            buttonLink: null,
            buttonTarget: null,
            hrefAttribute: null
        }
    },
    computed: {
        newLink: function() {
            return this.link;
        },
        newTarget: function() {
            return this.target;
        }
    },
    created() {
        this.buttonLabel = this.button ? this.button.text || this.label : this.label;
        this.buttonLink = this.button ? this.button.link || this.link : this.link;
        this.buttonTarget = this.button ? this.button.target || this.target : this.target;
        this.updateHrefAttributeIfHasLink();
        this.updateTargetAttributeIfHasLink();
        this.classes = [this.button ? this.button.styles || this.displayStyle : this.displayStyle];

        if (this.button?.displayOnlyOn) {
            if (this.button.displayOnlyOn === 'desktop') {
                this.classes.push('hide-on-mobile');
            } else if (this.button.displayOnlyOn === 'mobile') {
                this.classes.push('hide-on-desktop');
            }
        }
    },
    methods: {
        sendClickEvent() {
            if (this.button?.elementToClick) {
                document.querySelector(this.decodeHtml(this.button.elementToClick))?.click();
            }
            
            this.$emit('click');
        },
        click() {
            this.$refs.link.click();
        },
        updateHrefAttributeIfHasLink() {
            this.hrefAttribute = this.buttonLink ? 'href' : '';
        },
        updateTargetAttributeIfHasLink() {
            this.targetAttribute = this.buttonTarget ? 'target' : '';
        },
    },
    watch: {
        newLink: function() {
            this.buttonLink = this.link;
            this.updateHrefAttributeIfHasLink();
        },
        newTarget: function() {
            this.buttonTarget = this.target;
            this.updateTargetAttributeIfHasLink();
        }
    }
};

export default cta;